import * as yup from 'yup';
import { values, Weekdays } from '../../enums';

export const SocialCareEventSchema = yup.object({
  residentId: yup.string().required(),
  startDate: yup.date().required(),
  endDate: yup.date().notRequired().nullable(),
  endedAt: yup.date().notRequired().nullable(),
  plannedDays: yup.array().of(yup.mixed().oneOf(values(Weekdays)).required()),
  name: yup.string().required(),
  isPlanned: yup.boolean().required(),
  remark: yup.string().notRequired().nullable(),
});

export interface ISocialCareEvent {
  residentId: string;
  startDate: Date;
  endDate?: Date;
  endedAt?: Date;
  plannedDays: Weekdays[];
  name: string;
  isPlanned: boolean;
  remark?: string;
}

export const UpdateSocialCareEventSchema = yup.object({
  id: yup.string().required(),
  residentId: yup.string().notRequired(),
  startDate: yup.date().notRequired(),
  endDate: yup.date().notRequired().nullable(),
  endedAt: yup.date().notRequired().nullable(),
  plannedDays: yup.array().of(yup.mixed().oneOf(values(Weekdays)).notRequired()),
  name: yup.string().notRequired(),
  isPlanned: yup.boolean().notRequired(),
  remark: yup.string().notRequired().nullable(),
});

export interface IUpdateSocialCareEvent {
  id: string;
  residentId?: string;
  startDate?: Date;
  endDate?: Date;
  endedAt?: Date;
  plannedDays?: Weekdays[];
  name?: string;
  isPlanned?: boolean;
  remark?: string;
}
